import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	GET_LANGUAGES_PRICING,
	GET_PRICING,
	GET_WORDS_PRICING,
	GET_BRANCHS_PRICING,
	GET_COMPLETION_TIMES_PRICING,
	EDIT_PRICING,
	ADD_NEW_PRICING
} from '../constants/Pricing';
import {
	getPricingSuccess,
	getPricingError,
	getLanguagesPricingSuccess,
	getLanguagesPricingError,
	getBranchsPricingSuccess,
	getBranchsPricingError,
	getCompletionTimesPricingSuccess,
	getCompletionTimesPricingError,
	getWordsPricingSuccess,
	getWordsPricingError,
	editPricingSuccess,
	editPricingError,
	addNewPricingSuccess,
	addNewPricingError
} from "../actions/Pricing";

import {
	getLanguagesPricingService,
	getBranchsPricingService,
	getCompletionTimesPricingService,
	getWordsPricingService,
	editPriceService,
	getPricingService,
	addNewPriceService,
} from 'redux/services/Pricing';

export function* getPricingSaga() {
	yield takeEvery(GET_PRICING, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getPricingService, query);
			if (data.message) {
				yield put(getPricingError(data.message));
			} else {
				yield put(getPricingSuccess(data));
			}
		} catch (err) {
			yield put(getPricingError(err));
		}
	});
}

export function* getLanguagesPricingSaga() {
	yield takeEvery(GET_LANGUAGES_PRICING, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getLanguagesPricingService, query);
			if (data.message) {
				yield put(getLanguagesPricingError(data.message));
			} else {
				yield put(getLanguagesPricingSuccess(data));
			}
		} catch (err) {
			yield put(getLanguagesPricingError(err));
		}
	});
}

export function* getBranchsPricingSaga() {
	yield takeEvery(GET_BRANCHS_PRICING, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getBranchsPricingService, query);
			if (data.message) {
				yield put(getBranchsPricingError(data.message));
			} else {
				yield put(getBranchsPricingSuccess(data));
			}
		} catch (err) {
			yield put(getBranchsPricingError(err));
		}
	});
}

export function* getWordsPricingSaga() {
	yield takeEvery(GET_WORDS_PRICING, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getWordsPricingService, query);
			if (data.message) {
				yield put(getWordsPricingError(data.message));
			} else {
				yield put(getWordsPricingSuccess(data));
			}
		} catch (err) {
			yield put(getWordsPricingError(err));
		}
	});
}

export function* getCompletionTimesPricingSaga() {
	yield takeEvery(GET_COMPLETION_TIMES_PRICING, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getCompletionTimesPricingService, query);
			if (data.message) {
				yield put(getCompletionTimesPricingError(data.message));
			} else {
				yield put(getCompletionTimesPricingSuccess(data));
			}
		} catch (err) {
			yield put(getCompletionTimesPricingError(err));
		}
	});
}

export function* editPriceSaga() {
	yield takeEvery(EDIT_PRICING, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			let fetchedData = data.values;
			fetchedData = {
				...fetchedData,
				serviceId: fetchedData.service
			}
			const result = yield call(editPriceService, data.id, fetchedData);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editPricingError(result.message));
			} else {
				yield call(cb, { message: 'Price saved', type: 'success' });
				yield put(editPricingSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editPricingError(err));
		}
	});
}

export function* addNewPriceSaga() {
	yield takeEvery(ADD_NEW_PRICING, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			let fetchedData = data.values;
			fetchedData = {
				...fetchedData,
				serviceId: fetchedData.service
			}
			console.log(fetchedData);
			const result = yield call(addNewPriceService, fetchedData);
			console.log(result);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addNewPricingError(result.message));
			} else {
				yield call(cb, { message: 'Price saved', type: 'success' });
				yield put(addNewPricingSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addNewPricingError(err));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getPricingSaga),
		fork(getLanguagesPricingSaga),
		fork(getBranchsPricingSaga),
		fork(getWordsPricingSaga),
		fork(getCompletionTimesPricingSaga),
		fork(editPriceSaga),
		fork(addNewPriceSaga)
	]);
}
